const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchMovimientosClientes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-clientes/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimientos de clientes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientosClientes:', error);
    throw error;
  }
};

export const fetchMovimientosByCliente = async (clienteId, limit = 100, page = 1) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-clientes/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        limit,
        page,
        query: { clienteId },
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimientos del cliente');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientosByCliente:', error);
    throw error;
  }
};
